import root from 'window-or-global';
import { log } from 'utils/error-logging';

import { getImpactIdentify } from 'redux/modules/impact/selectors';

export const identifyCustomer = (getState: WtrGetState) => {
  const identify = getImpactIdentify(getState());

  if (root.ire) {
    // Send event using the Impact Radius Event API
    root.ire('identify', { ...identify, customProfileId: '' });
  } else {
    log(new Error('Impact identify attempted but root.ire unavailable'), {
      logger: 'impact-loader',
    });
  }
};
